// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
import regexSupplant from '../lib/regexSupplant';
import spacesGroup from './spacesGroup';
export default regexSupplant(/[#{spacesGroup}]/, {
  spacesGroup: spacesGroup
});